import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetSurveyDashboardPreferencesRPC } from "./getSurveyDashboardPreferencesRPC";

export class GetSurveyDashboardPreferencesRPCClientImpl extends GetSurveyDashboardPreferencesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetSurveyDashboardPreferencesRPC.Request): Promise<LeoRPCResult<GetSurveyDashboardPreferencesRPC.Response, GetSurveyDashboardPreferencesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-dashboard/GetSurveyDashboardPreferences",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetSurveyDashboardPreferencesRPC.ResponseDTO,
      GetSurveyDashboardPreferencesRPC.Errors.ErrorsDTO,
      GetSurveyDashboardPreferencesRPC.Response,
      GetSurveyDashboardPreferencesRPC.Errors.Errors
    >(
      response,
      "survey-dashboard/GetSurveyDashboardPreferences",
      GetSurveyDashboardPreferencesRPC.Response.fromDTO,
      GetSurveyDashboardPreferencesRPC.Errors.fromDTO
    );
  }
}
